const getCarStatusType = (vehicle_status: string, t: any) => {
  const status = Number(vehicle_status);
  let str = "";
  if (vehicle_status != null) {
    switch (status) {
      case 0:
        str = t("initialization");
        break;
      case 1:
        str = t("dormancy");
        break;
      case 2:
        str = t("remotecontrolready");
        break;
      case 3:
        str = t("idle");
        break;
      case 4:
        str = t("remotecontroldriving");
        break;
      case 5:
        str = t("autonomousdriving");
        break;
      case 6:
        str = t("manualintervention");
        break;
      case 7:
        str = t("crashstop");
        break;
      case 8:
        str = t("fault");
        break;
      case 9:
        str = t("supplying");
        break;
      case 10:
        str = t("shutdown");
        break;
      case 11:
        str = t("forcedlabor");
        break;
      case 20:
        str = t("duringcleaning");
        break;
      case 21:
        str = t("gotosupply");
        break;
      case 22:
        str = t("gotodock");
        break;
      case 23:
        str = t("supplying");
        break;
    }
  }
  return str;
};
const getTaskType = (task_type: string, t: any) => {
  const status = Number(task_type);
  let str = t("nothave");
  switch (status) {
    case 1:
      str = t("combinedtasks");
      break;
    case 2:
      str = t("multifloortasks");
      break;
    default:
      str = " ";
      break;
  }
  return str;
};

const getTaskState = (type: number, t: any) => {
  const status = Number(type);
  let str = "";
  switch (status) {
    case 0:
      str = t("notstarted");
      break;
    case 1:
      str = t("underexecution");
      break;
    case 2:
      str = t("completed");
      break;
    case 3:
      str = t("abnormalend");
      break;
    case 4:
      str = t("paused");
      break;
    case 5:
      str = t("proactivelyending");
      break;
    default:
      str = " ";
      break;
  }
  return str;
};

const getCarLocationStatus = (vehicle_status: string, t: any) => {
  const status = Number(vehicle_status);
  let str = t("nothave");
  switch (status) {
    case 0:
      str = t("positioningsuccessful");
      break;
    case 1:
      str = t("generalpositioning");
      break;
    case 2:
      str = t("positioningfailed");
      break;
    case 3:
      str = t("imuinitialization");
      break;
    case 4:
      str = t("laserinitialization");
      break;
    case 5:
      str = t("autonomousdriving");
      break;
    case 6:
      str = t("mapsloading");
      break;
    default:
      str = "--";
      break;
  }
  return str;
};
export { getCarStatusType, getTaskType, getTaskState, getCarLocationStatus };
